import {
  formatPercent,
  formatTextFloat,
  formatValue,
  formatValueBillion,
  formatValueTrillion,
} from '../../helpers/Text';
import {
  formatBillionKeys,
  formatIntegerKeys,
  formatMillionKeys,
  formatPercentKeys,
  formatTrillionKeys,
} from './constants';

const reverseObject = obj => {
  const result = {};
  Object.keys(obj).forEach(key => {
    result[obj[key]] = key;
  });

  return result;
};

export const formatFinancialRatioData = (data, mapping) => {
  if (!Array.isArray(data)) {
    return {};
  }
  const result = {};
  data.forEach(item => {
    if (!item.value) {
      item.value = {};
      return;
    }
    if (!item.value) {
      return {};
    }
    const parsedValue = {};
    const reverseMapping = reverseObject(mapping);
    Object.keys(item.value).forEach(key => {
      const parsedKey = reverseMapping[key];
      if (formatPercentKeys.includes(key)) {
        if (!item.value[key]) {
          parsedValue[parsedKey] = '--';
          return;
        }
        parsedValue[parsedKey] = `${formatTextFloat(
          formatPercent(item.value[key]),
        )}%`;
        return;
      }

      if (formatBillionKeys.includes(key)) {
        parsedValue[parsedKey] = formatTextFloat(
          formatValueBillion(item.value[key]),
          2,
          true,
        );
        return;
      }

      if (formatMillionKeys.includes(key)) {
        parsedValue[parsedKey] = formatTextFloat(
          formatValue(item.value[key]),
          2,
          true,
        );
        return;
      }

      if (formatTrillionKeys.includes(key)) {
        parsedValue[parsedKey] = formatTextFloat(
          formatValueTrillion(item.value[key]),
          2,
          true,
        );
        return;
      }

      if (formatIntegerKeys.includes(key)) {
        parsedValue[parsedKey] = formatTextFloat(item.value[key], 0, true);
        return;
      }

      parsedValue[parsedKey] = formatTextFloat(item.value[key], 2, true);
    });

    result[item.key] = parsedValue;
  });

  return result;
};
